import React, { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);

  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      style={{
        width: 36,
        height: 36,
        borderRadius: 8,
        border: "1px solid var(--border)",
        background: hovered ? "var(--card-bg)" : "var(--bg-color)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "background 200ms ease",
        outline: "none",
        boxShadow: focused ? "0 0 0 2px #60a5fa" : "none",
        flexShrink: 0,
      }}
    >
      <div style={{ position: "relative", width: 20, height: 20 }}>
        <Sun style={{
          position: "absolute",
          inset: 0,
          width: 20,
          height: 20,
          color: "var(--color)",
          transition: "transform 300ms ease, opacity 300ms ease",
          transform: isDark ? "scale(0) rotate(90deg)" : "scale(1) rotate(0deg)",
          opacity: isDark ? 0 : 1,
        }} />
        <Moon style={{
          position: "absolute",
          inset: 0,
          width: 20,
          height: 20,
          color: "var(--color)",
          transition: "transform 300ms ease, opacity 300ms ease",
          transform: isDark ? "scale(1) rotate(0deg)" : "scale(0) rotate(-90deg)",
          opacity: isDark ? 1 : 0,
        }} />
      </div>
    </button>
  );
};

export default ThemeToggle;